import type { FC } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

type Props = TabsProps & {
  /** 模块级下划线 Tab（看板概览/汇报/监控） */
  module?: boolean;
};

/** Showcase §4 Tabs；module=true 时应用 ipc-module-tabs 布局 */
export const IpcModuleTabs: FC<Props> = ({ module = true, className, ...rest }) => {
  const classes = [module ? 'ipc-module-tabs' : 'ipc-tabs', className].filter(Boolean).join(' ');
  return <Tabs {...rest} className={classes} />;
};
